import PrintReportList from "./pages/PrintReportList.vue";
import PrintReportView from "./pages/PrintReportView.vue";
import PrintReportEdit from "./pages/PrintReportEdit.vue";

export default {
    PrintReportList,
    PrintReportView,
    PrintReportEdit,
};
